(function() {
    'use strict';

    angular
        .module('invesfleet')
        .controller('PartnerListController', PartnerListController);
    

    PartnerListController.$inject = [
		'$templateCache',  'colaboradorService', '$scope', '$rootScope', '$state', '$filter'
    ];

    

	function PartnerListController($templateCache, colaboradorService, $scope, $rootScope, $state, $filter){
        // jshint maxstatements:false

        /* PRIVATE VARIABLES */
        var templates = {
			accionesCellTemplate: $templateCache.get('app/views/tablesTemplates/generic/accionesCellTemplate.html'),
			rowTemplate: $templateCache.get('app/views/tablesTemplates/generic/rowTemplate.html'),
        };

        var vm = this;
        vm.gridData = [];
        vm.gridOptions = {
            rowTemplate: templates.rowTemplate,

            columnDefs: [

                {
                    name: 'id',
                    displayName: 'ID',
                    minWidth: 110,
                    maxWidth: 125,
                    resizable: true
                },

                {
                    name: 'nombre',
                    displayName: 'Nombre',
                    minWidth: 110,
                    maxWidth: 125,
                    resizable: true
                },

                {
                     field: 'direccion',
                     displayName: 'Dirección',
                },

                {
                     field: 'poblacion',
                     displayName: 'Población',
                },

                {
                     field: 'provincia',
                     displayName: 'Provincia',
                },

                {
                     field: 'telefono',
                     displayName: 'Teléfono',
                },

                {
                    field: 'actions',
                    displayName: 'Acciones',
                    minWidth: 110,
                    maxWidth: 125,
                    resizable: true,
                    cellClass: 'overflow',
                    cellTemplate: templates.accionesCellTemplate
                }

             ],
			data: 'gridData',

			onRegisterApi: function (gridApi) {
				vm.gridApi = gridApi;
				vm.gridApi.grid.options.enableExpandAll = false;
			}
        };

        vm.goToEdit = goToEdit;

        (function () {
            loadData();
        })();


		function loadData() {
			colaboradorService.getList().then(function (result) {
				$scope.gridData = result.data.list;
				vm.gridData = result.data.list;
			});
        }
        
        function goToEdit(col) {
			$state.go('flota.colaboradores.editar', { 'id': col.colaboradorId });
		}
    }

})();
